import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class OnlinePaymentService {
  private url: string = 'online_payments';

  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

	  getSearchOptions(): Promise<any> {
	    return this.httpClient.get(`${this.url}/search_options.json`);
	  }

	  refund(provider: string, id: number, amount?: number, reason?: string): Promise<any> {
	    const data: any = {};
	    if (amount !== undefined && amount !== null) {
	      data.amount = amount;
	    }
	    if (reason) {
	      data.reason = reason;
	    }
	    return this.httpClient.post(`${this.url}/${provider}/${id}/refund.json`, data);
	  }
	}
